/**
 *
 * @module access
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import AccessContextState from './accessContextState';

const AccessContext = Services.Token.AccessContext;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class Access
 * @desc An interface with a reference to AccessContext and AccessContextState, used to
 * group the two as they are expected to be sent over and stored together.
 *
 */
export default class Access {

    /**
     *
     * @param {SDK.Services.Token.AccessContext} context
     * @param {AccessContextState} contextState
     * @throws {InvalidArgumentException}
     *
     */
    constructor(context, contextState) {

        const errorMessage = {
            ctor: 'Access(context, contextState)',
            get context() {
                return `${this.ctor} needs AccessContext instance`;
            },
            get contextState() {
                return `${this.ctor} needs valid AccessContextState`;
            }
        };

        instanceStrict(context, AccessContext, errorMessage.context, InvalidArgumentException);
        instanceStrict(contextState, AccessContextState, errorMessage.contextState, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {SDK.Services.Token.AccessContext}
         *
         */
        this.context = context;

        /**
         *
         * @access public
         * @type {AccessContextState}
         *
         */
        this.contextState = contextState;

    }

}



// WEBPACK FOOTER //
// ./src/token/access.js